export const Company = {
  RECEPTOUR: 1,
  WINDIGO: 2,
};
